import React, { useState, useMemo } from 'react';
import { uploadFileBase } from '@utils/uploadFileBase';

import { observer } from 'mobx-react';
import { useDropzone } from 'react-dropzone';
import { Dimmer, Loader, Icon } from 'semantic-ui-react';
import './DragDrop.scss';
import store from '../store';
import { notification } from 'antd';
import customFetch from '@utils/customFetch';
import { GetFileExtention } from '@utils/functions';
import { renderDate } from '../../Shared';
import { AllowedFileExtensions } from '@utils/constants';

function DragDropFile(props) {
  const [loading, setLoading] = useState(false);
  const { clinicalNoteInfo } = store;
  const uploadFile = store.renderAttachment(clinicalNoteInfo.Attachments, props.type);

  //list MIME - https://stackoverflow.com/questions/4212861/what-is-a-correct-mime-type-for-docx-pptx-etc
  const acceptFile = AllowedFileExtensions;

  const onDrop = async acceptedFiles => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      setLoading(true);
      const res = await uploadFileBase(acceptedFiles, props.maxSize);
      if (res != null) {
        props.onUploadFile && props.onUploadFile(res.fileList, props.type);
        setLoading(false);
      }
    } else {
      const { accept } = props;
      if (accept === 'application/pdf') {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description: 'Only pdf files are accepted. Please choose a different file.',
        });
      }
    }
  };
  const removeAtt = file => {
    if (props.type === 7) {
      store.toggleModalModalUpload(false);
      store.toggleModalConfirm(true, {
        message: 'Are you sure delete all merged files',
        onOk: () => {
          customFetch('/ClinicalNote/DeleteMergeCRFiles', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              clinicalNoteId: store.clinicalNoteInfo.Id,
              type: 'AttachedCRFiles',
            }),
          }).then(res => {
            if (res.status === 'success') {
              store.handleChangeCRValue({
                Attachments: store.clinicalNoteInfo.Attachments.filter(i => i.ReportType !== 7),
              });
            }
          });
        },
      });
      return;
    }
    store.toggleModalModalUpload(false);
    return store.toggleModalConfirm(true, {
      message: 'Do you want to delete this file?',
      onOk: () => {
        return props.onDeleteFile && props.onDeleteFile(file);
      },
    });
  };

  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop,
    accept: props.accept ? props.accept : acceptFile,
    maxSize: (props?.maxSize || 100) * 1021000,
  });
  // const handleOpenAttachment = fileName => () => {
  //   return window.open(`/UserFile/ClinicalNoteAttachment/${fileName}`, '_blank');
  // };

  const files = () => {
    if (uploadFile && uploadFile.length > 0) {
      return uploadFile.map((file, idx) => {
        return (
          <li className="list-file" key={idx}>
            <a
              href={`/UserFile/ClinicalNoteAttachment/${file.FileName}`}
              download={file.Title + GetFileExtention(file.FileName)}
            >{`${file.Title}${GetFileExtention(file.FileName)} ${
              file.NumberOfPages ? ` - ${file.NumberOfPages} ${file.NumberOfPages > 1 ? 'pages' : 'page'}` : ''
            } ${file.CreatedDate ? ` - ${renderDate(file.CreatedDate, false, true)}` : ''}`}</a>
            {!props.disabledDelete && (
              <span
                onClick={() => {
                  !props.disabledDelete && removeAtt(file.key);
                }}
                style={{ color: 'red', marginLeft: '5px', cursor: 'pointer' }}
              >
                {props.type !== 7 ? 'Delete' : 'Delete Merge Files'}
              </span>
            )}
          </li>
        );
      });
    }
    return;
  };

  const style = useMemo(
    () => ({
      ...{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px 10px',
        fontSize: '15px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#1db4cd',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        fontWeight: 'bold',
        outline: 'none',
        transition: 'border .24s ease-in-out',
        cursor: !props.disabled ? 'pointer' : 'not-allowed',
      },
      ...(isDragActive ? { borderColor: '#2196f3', backgroundColor: 'rgb(194, 243, 194)' } : {}),
      ...(isDragAccept ? { borderColor: '#00e676' } : {}),
      ...(isDragReject ? { backgroundColor: 'rgb(255 192 192)' } : {}),
    }),
    [isDragActive, isDragReject, isDragAccept, props.disabled],
  );

  return (
    <section>
      <Dimmer active={loading}>
        <Loader />
      </Dimmer>

      {!(!!uploadFile.length && !props.multiple) && !props.isViewMergeFile && !props.disabled && (
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} multiple={props.multiple} disabled={props.disabled} />
          <Icon name="upload" className="upload-icon"></Icon>
          <span style={{ color: '#1db4cd' }}>Drag-n-drop here or Click to browse</span>
          <span>
            ({props.uploadTitle ? props.uploadTitle + ', ' : ''}
            {props.maxSize > 0 && `${props.uploadTitle ? 'max' : 'Max'} ${props.maxSize}MB`})
          </span>
        </div>
      )}
      <aside>
        <ul className="list-file-ul">{files()}</ul>
      </aside>
    </section>
  );
}

export default observer(DragDropFile);
